import request from '../kernel/request'

export default {
    card:{
        list(params) {
            return request.get('card', params)
        },
        page(params) {
            return request.get('card/page', params)
        },
        save(data) {
            return request.post('card/save', data)
        },
        update(data) {
            return request.put('card/update/member', data)
        },
        load(id) {
            return request.get('card/loadBy/' + id)
        },
        delete(id) {
            return request.delete('card/' + id)
        }
    },
    member: {
        list(params) {
            return request.get('member', params)
        },
        page(params) {
            return request.get('member/page', params)
        },
        stuPage(params) {
            return request.get('member/page/stu', params)
        },
        presentPage(params) {
            return request.get('member/present/page', params)
        },
        commonPage(params) {
            return request.get('member/common/page', params)
        },
        allot(params) {
            return request.post('member/allot', params)
        },
        test(params) {
            return request.post('member/test', params)
        },
        myMember(params) {
            return request.get('member/my', params)
        },
        myMarket(params) {
            return request.get('member/myMarket', params)
        },
        market(params) {
            return request.get('member/market/page', params)
        },
        selectBy(params) {
            return request.get('member/by', params)
        },
        leadMember: `${request.baseURL}/member/excel`,

        search(params) {
            return request.get('member/search/list', params)
        },
        save(data) {
            return request.post('member/save', data)
        },
        update(data) {
            return request.put('member/update', data)
        },
        upPhoto(id, data) {
            return request.put('member/upPhoto/' + id, data)
        },
        updateIdentity( data) {
            return request.put('member/update/Identity', data)
        },
        upIdentity(id, data) {
            return request.put('member/upIdentity/' + id, data)
        },
        upPhone(data) {
            return request.put('member', data)
        },
        load(id) {
            return request.get('member/' + id)
        },
        loadCharge(id) {
            return request.get('member/loadCharge/' + id)
        },
        gcdfOpen(id) {
            return request.get('member/gcdf/open/' + id)
        },
        loadBy(id) {
            return request.get('member/load/' + id)
        },
        birthNum(data) {
            return request.get('member/birth',data)
        },
        birthList(data) {
            return request.get('member/birth/list',data)
        },
        delete(id) {
            return request.delete('member/' + id)
        },
        uploadUrl: `${request.baseURL}/member/uploadLic`,
        uploadPhoto: `${request.baseURL}/member/uploadPhoto`,
        uploadIdentity: `${request.baseURL}/member/uploadIdentity`,
        loadMemberInfo(id) {
            return request.get('/member/info/' + id)
        },
        loadRecords(id){
            return request.get('member/records/' + id)
        }
    },
    follow: {
        list(params) {
            return request.get('market/follow', params)
        },
        page(params) {
            return request.get('market/follow/page', params)
        },
        record(params) {
            return request.get('market/follow/record', params)
        },
        save(data) {
            return request.post('market/follow/save', data)
        },
        gcdfSave(data) {
            return request.post('market/follow/gcdf/save', data)
        },
        update(data) {
            return request.put(`market/follow`, data)
        },
        load(id) {
            return request.get('market/follow/' + id)
        },
        delete(id) {
            return request.delete('market/follow/' + id)
        }
    },
    edu: {
        list(params) {
            return request.get('edu', params)
        },
        page(params) {
            return request.get('edu/page', params)
        },
        save(data) {
            return request.post('edu/save', data)
        },
        update(data) {
            return request.put(`edu`, data)
        },
        load(id) {
            return request.get('edu/' + id)
        },
        delete(id) {
            return request.delete('edu/' + id)
        },
        uploadUrl: `${request.baseURL}/edu/uploadLic`,
        uploadRecordPdf: `${request.baseURL}/edu/uploadRecordPdf`
    },
    train: {
        list(params) {
            return request.get('train', params)
        },
        page(params) {
            return request.get('train/page', params)
        },
        save(data) {
            return request.post('train/save', data)
        },
        update(data) {
            return request.put(`train`, data)
        },
        load(id) {
            return request.get('train/' + id)
        },
        delete(id) {
            return request.delete('train/' + id)
        },
        uploadUrl: `${request.baseURL}/train/uploadLic`
    },
    career: {
        list(params) {
            return request.get('career/record', params)
        },
        page(params) {
            return request.get('career/record/page', params)
        },
        save(data) {
            return request.post('/career/record/save', data)
        },
        update(data) {
            return request.put(`career/record`, data)
        },
        load(id) {
            return request.get('career/record/' + id)
        },
        delete(id) {
            return request.delete('career/record/' + id)
        }
    },
    relation: {
        list(params) {
            return request.get('relation', params)
        },
        page(params) {
            return request.get('/relation/page', params)
        },
        save(data) {
            return request.post('/relation/save', data)
        },
        update(data) {
            return request.put(`relation`, data)
        },
        load(id) {
            return request.get('relation/' + id)
        },
        delete(id) {
            return request.delete('relation/' + id)
        }
    },
    memberBase: {
        list(params) {
            return request.get('member/base', params)
        },
        page(params) {
            return request.get('/member/base/page', params)
        },
        save(data) {
            return request.post('/member/base/save', data)
        },
        update(data) {
            return request.put(`member/base`, data)
        },
        load(id) {
            return request.get('member/base/' + id)
        },
        loadBy(id) {
            return request.get('member/base/loadBy/' + id)
        },
        delete(id) {
            return request.delete('member/base/' + id)
        }
    },
}
